export function getParams(state) {
    return state.params;
}

export function getProductDataSheet(state) {
    return state.data_sheets;
}

export function ListProductsTable(state) {
    return state.tableProduct;
}

export function detailLoadFile (state) {
    return state.loadImages
}

export function getB2cIntegrations(state) {
    return state.b2cIntegrations;
}



// WEBPACK FOOTER //
// ./src/modules/products/getters.js